import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import ProtectedRoute, { homeFor } from "./components/ProtectedRoute";
import Login from "./pages/Login";
import AdminApp from "./pages/AdminApp";
import ParticipantApp from "./pages/ParticipantApp";
import RaterApp from "./pages/RaterApp";
import LandingPage from "./pages/LandingPage";
import CertificateVerify from "./pages/CertificateVerify";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <LandingPage />;
  return <Navigate to={homeFor(user.role)} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/verify/:certId" element={<CertificateVerify />} />
          <Route path="/" element={<RootRedirect />} />
          <Route path="/admin/*" element={
            <ProtectedRoute roles={["admin", "client_lead"]}><AdminApp /></ProtectedRoute>
          } />
          <Route path="/participant/*" element={
            <ProtectedRoute roles={["participant"]}><ParticipantApp /></ProtectedRoute>
          } />
          <Route path="/rater/*" element={
            <ProtectedRoute roles={["manager", "channel_partner"]}><RaterApp /></ProtectedRoute>
          } />
          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
